var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var cio_config = require("cio-config");
var PackageGeneratorInspectorConfig = require("../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../shared/extensions/footprintGenerator/ipcImages/index.js");
var IpcImageHelper = require('../../../../shared/extensions/footprintGenerator/ipcImageHelper.js');

if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");

var IpcPthPadGeneratorInteractionModel = require('./ipcPthPadGeneratorInteractionModel.js');

var RadialLedRoundPadGeneratorInteractionModel = function(IpcPthPadGeneratorData, userSettingsModel, showFootprintParams) {
    IpcPthPadGeneratorInteractionModel.apply(this, arguments);

    this.colorList = [];
    this.bodyColorList = this.value("bodyColorList", true);

    this.leadShape = this.shadow("leadShape",
        function() {
            return this.data.leadShape();
        },
        function(value) {
            return this.data.leadShape(value);
        },
        [this.data.leadShape]
    );

    this.terminalThickness = this.shadow("terminalThickness",
        function() {
            return this.data.terminalThickness() / this.getUnitFactor();
        },
        function(value) {
            return this.data.terminalThickness(parseFloat(value) * this.getUnitFactor());
        },
        [
            this.data.terminalThickness, this.userSettingsModel.distanceUnit
        ]
    );
    this.showTerminalWidthAndThickness = this.shadow("showTerminalWidthAndThickness",
        function() {
            return this.data.leadShape() === cio_datamodel.IpcDataModel.PthComponentAttribute.leadShapes["Rectangle"];
        },
        null,
        [
            this.data.leadShape
        ]
    );
    this.showTerminalDiameter = this.shadow("showTerminalDiameter",
        function() {
            return this.data.leadShape() === cio_datamodel.IpcDataModel.PthComponentAttribute.leadShapes["Round"];
        },
        null,
        [
            this.data.leadShape
        ]
    );
    this.bodyOffset = this.shadow("bodyOffset",
        function() {
            return this.data.bodyOffset() / this.getUnitFactor();
        },
        function(value) {
            return this.data.bodyOffset(parseFloat(value) * this.getUnitFactor());
        },
        [
            this.data.bodyOffset, this.userSettingsModel.distanceUnit
        ]
    );
    this.bodyColor = this.shadow("bodyColor",
        function() {
            return this.data.bodyColor();
        },
        function(value) {
            return this.data.bodyColor(value);
        },
        [this.data.bodyColor]
    );

    this.customBodyColor = this.shadow("customBodyColor",
        function() {
            return this.data.customBodyColor();
        },
        function(value) {
            return this.data.customBodyColor(value);
        },
        [this.data.customBodyColor]
    );

     this.showCustomBodyColorField = this.shadow("showCustomBodyColorField",
        function() {
            return !this.data.bodyColor()
        },
        null,
        [
            this.data.bodyColor
        ]
    );

    //body color list
    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.LED) {
        var r = cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.LED[t].key;
        this.colorList.push([this.LCLZ(r, r), cio_datamodel.IpcDataModel.PthComponentAttribute.bodyColors.RADIAL.ROUND.LED[t].value]);
    }
    this.bodyColorList(this.colorList);

};

lib_core.inherit(RadialLedRoundPadGeneratorInteractionModel, IpcPthPadGeneratorInteractionModel);
RadialLedRoundPadGeneratorInteractionModel.$class = 'RadialLedRoundPadGeneratorInteractionModel';

module.exports = RadialLedRoundPadGeneratorInteractionModel;

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForLeadShape = function() {
    var leadShapeList = [];
    for (var t in cio_datamodel.IpcDataModel.PthComponentAttribute.leadShapes) {
        var s = cio_datamodel.IpcDataModel.PthComponentAttribute.leadShapes[t];
        if (s != cio_datamodel.IpcDataModel.PthComponentAttribute.leadShapes["Square"]) {
            leadShapeList.push([this.LCLZ(t, s), s]);
        }
    }  
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('leadShape', 'Lead Shape'), this.leadShape, leadShapeList)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b',this.LCLZ('leadWidth', 'Lead Width'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit,false, this.showTerminalWidthAndThickness)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalDiameter = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('b',this.LCLZ('leadDiameter', 'Lead Diameter'), true, null, false, this.terminalWidth, this.userSettingsModel.distanceUnit, false, this.showTerminalDiameter)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalThickness = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('c', this.LCLZ('leadThickness', 'Lead Thickness'), true, null, false, this.terminalThickness, this.userSettingsModel.distanceUnit, false, this.showTerminalWidthAndThickness)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('bodyDiameter', 'Body Diameter'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForBodyOffset = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('A1', this.LCLZ('bodyOffset', 'Body Offset'), this.bodyOffset, this.userSettingsModel.distanceUnit)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForBodyColor = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('bodyColor', 'Body Color'), this.bodyColor, this.bodyColorList)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElementForCustomBodyColor = function() {
    return [PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('customBodyColor', 'Custom Body Color'), this.customBodyColor, this.showCustomBodyColorField, cio_config.types.string)];
};

RadialLedRoundPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('ledColorNote', '* Enter value in Hex for custom body color.')));
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('radialLedNote', '* c is not applicable for rounded lead shape.')));
    imElements = imElements.concat(this.getInspectorElementForBodyColor());
    imElements = imElements.concat(this.getInspectorElementForCustomBodyColor());
    imElements = imElements.concat(this.getInspectorElementForLeadShape());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForTerminalDiameter());
    imElements = imElements.concat(this.getInspectorElementForTerminalThickness());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForPadHoleRatio());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};
